/* istanbul ignore file */
import { thresholdData } from "../reducers/thresholdSlice";


export const thresholdDataSave = (data) => async (dispatch) => {
	dispatch(thresholdData(data));
};